@if (session.learner) {
  <header translate [translateParams]="{ name: session.learner?.name }">
    retake-request-submitted.component.greeting
  </header>

  <p translate [translateParams]="{ retakenAt: retakeRequest.retakenAt | date: 'medium' }">
    retake-request-submitted.component.retaken-at
  </p>

  <main>
    <figure>
      <img [src]="identification.facePhoto.url" />
      <figcaption translate>retake-request-submitted.component.face-photo</figcaption>
    </figure>

    <figure>
      <img [src]="identification.idPhoto.url" />
      <figcaption translate>retake-request-submitted.component.id-photo</figcaption>
    </figure>
  </main>
}
